import React from "react";
import Select from "react-select";
import { Field } from "formik";
import "./form-elements.scss";

const MultiSelect = ({
  name,
  placeholder,
  data,
  disabled,
  defaultValueArr,
  setMultiSelectVal,
}) => {
  //const [stateVal, setStateVal] = useState(defaultValueArr);
  let npRecord = [];
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        return (
          <div>
            {name === "edit" ? (
              <Select
                defaultValue={defaultValueArr}
                isMulti
                placeholder={placeholder}
                options={data[0].value !== "" ? data : npRecord}
                className="basic-multi-select"
                classNamePrefix="select"
                isSearchable={false}
                isDisabled={disabled}
                isClearable={false}
                onChange={(data, index) => {
                  if (data !== null) {
                    form.setFieldValue(name, data);
                  } else {
                    form.setFieldValue(name, "");
                  }
                }}
              />
            ) : (
              <Select
                // value={defaultValueArr}
                closeMenuOnSelect={false}
                defaultValue={defaultValueArr}
                isMulti
                placeholder={placeholder}
                options={data[0].value !== "" ? data : npRecord}
                className="basic-multi-select"
                classNamePrefix="select"
                isSearchable={false}
                isDisabled={disabled}
                noOptionsMessage={() => "No records"}
                isClearable={true}
                onChange={(data, index) => {
                  if (data !== null) {
                    if (setMultiSelectVal) setMultiSelectVal(data);
                    form.setFieldValue(name, data);
                  } else {
                    form.setFieldValue(name, "");
                  }
                }}
              />
            )}

            {meta.touched && meta.error && (
              <p name={name + "Error"} className="error-message">
                {meta.error}
              </p>
            )}
          </div>
        );
      }}
    </Field>
  );
};
export default MultiSelect;
